import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import AccountMenu from './AccountMenu';
import { CONTENTS, CONTENT_KEYS } from '../../constants/contents';

// ラベルと遷移先はプラン選択・マイページ・ロック表示でも使うので、定義を1箇所に寄せた（#36）
// 中央新版は中央競馬に一本化したのでナビから外した（#270）
const SERVICE_LINKS = CONTENT_KEYS.map((key) => ({ key, ...CONTENTS[key] }));

function PredictionServiceNav({ activeKey }) {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5 },
        borderRadius: 4,
        border: '1px solid rgba(92, 160, 219, 0.2)',
        background:
          'linear-gradient(180deg, rgba(10,24,41,0.92), rgba(4,10,20,0.95))',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.24)',
      }}
    >
      <Stack spacing={1.5}>
        <Box>
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
          >
            <Typography
              sx={{
                color: '#71dbff',
                fontSize: 12,
                letterSpacing: '0.24em',
                textTransform: 'uppercase',
              }}
            >
              Prediction Suites
            </Typography>
            <AccountMenu />
          </Stack>
          <Typography sx={{ mt: 1, fontSize: { xs: 22, sm: 28 }, fontWeight: 700 }}>
            ちりり競馬 AIサービス
          </Typography>
          <Typography sx={{ mt: 0.75, color: 'rgba(203, 229, 245, 0.72)', fontSize: 13 }}>
            中央競馬・地方競馬・競輪を同テイストでまとめています。
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gap: 1.25,
            gridTemplateColumns: {
              xs: 'repeat(2, minmax(0, 1fr))',
              sm: 'repeat(3, 104px)',
            },
            width: 'fit-content',
            maxWidth: '100%',
          }}
        >
          {SERVICE_LINKS.map((service) => {
            const isActive = service.key === activeKey;
            return (
              <Button
                key={service.key}
                component={NavLink}
                to={service.path}
                sx={{
                  width: '100%',
                  minWidth: 0,
                  px: 2,
                  py: 1.1,
                  borderRadius: 3,
                  textTransform: 'none',
                  alignItems: 'flex-start',
                  border: '1px solid',
                  borderColor: isActive
                    ? 'rgba(108, 247, 255, 0.42)'
                    : 'rgba(92, 160, 219, 0.18)',
                  background: isActive
                    ? 'linear-gradient(135deg, rgba(22,111,199,0.94), rgba(14,54,109,0.94))'
                    : 'linear-gradient(180deg, rgba(9,20,35,0.88), rgba(6,14,25,0.88))',
                  color: '#eef8ff',
                  boxShadow: isActive ? '0 0 22px rgba(76, 186, 255, 0.18)' : 'none',
                }}
              >
                <Box sx={{ textAlign: 'left' }}>
                  <Typography sx={{ fontWeight: 700 }}>{service.label}</Typography>
                  <Typography sx={{ mt: 0.4, fontSize: 11, color: 'rgba(200, 228, 245, 0.68)' }}>
                    {service.caption}
                  </Typography>
                </Box>
              </Button>
            );
          })}
        </Box>
      </Stack>
    </Box>
  );
}

export default PredictionServiceNav;
